export default "__VITE_ASSET___8SUA0de__"